import React, { FC } from 'react';
import { ButtonProps, ButtonUnstyled, Icon } from '@lambdacurry/component-library';
import classNames from 'classnames';
import './more-info-text-button.scss';

interface MoreInfoTextButton extends ButtonProps {
  className?: string;
  onClick: () => void;
}

export const MoreInfoTextButton: FC<MoreInfoTextButton> = ({ className, onClick, children, ...props }) => {
  return (
    <ButtonUnstyled
      {...props}
      className={classNames('more-info-text-button !underline uppercase', className)}
      onClick={onClick}
    >
      <Icon className="mr-2" name="info" aria-hidden="true" />
      {children ? children : 'More Info'}
    </ButtonUnstyled>
  );
};
